module.exports = __webpack_public_path__ + "img/1387.1b60a59f.gif";